import { IntlFormatters } from "react-intl";
import messages from "./messages";


export const stages = (fm: IntlFormatters["formatMessage"]) => [
    ["upload", fm(messages.upload), { start: 0, end: 0 }],
    ["systems", fm(messages.systems), { start: 1, end: 1 }],
    ["bars", fm(messages.bars), { start: 2, end: 3 }],
    ["non-bars", fm(messages.nonBars), { start: 4, end: 4 }],
    ["same", fm(messages.same), { start: 5, end: 5 }],
    ["size", fm(messages.size), { start: 6, end: 6 }],
    ["layout", fm(messages.layout), { start: 7, end: 7 }],
];

export const getStage = (currentStage: string, dir: number, formatMessage: IntlFormatters["formatMessage"]) => {
    let index = stages(formatMessage).findIndex(stage => stage[0] === currentStage);
    return stages(formatMessage)[index + dir][0] as string;
};

export const isAvailableStage = (latest: string, stage: string, formatMessage: IntlFormatters["formatMessage"]) => {
    let stageIndex = stages(formatMessage).findIndex(s => s[0] === stage);
    let latestIndex = stages(formatMessage).findIndex(s => s[0] === latest);
    return stageIndex <= latestIndex;
};

export const maxStage = (latest: string, stage: string, formatMessage: IntlFormatters["formatMessage"]) => {
    let stageIndex = stages(formatMessage).findIndex(s => s[0] === stage);
    let latestIndex = stages(formatMessage).findIndex(s => s[0] === latest);
    return stages(formatMessage)[Math.max(stageIndex, latestIndex)][0] as string;
};

export const getIndicesOf = (str: string, searchStr: string, caseSensitive = false) => {
    let searchStrLen = searchStr.length;
    if (searchStrLen === 0) {
        return [];
    }
    let startIndex = 0,
        index,
        indices = [];
    if (!caseSensitive) {
        str = str.toLowerCase();
        searchStr = searchStr.toLowerCase();
    }
    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
        indices.push(index);
        startIndex = index + searchStrLen;
    }
    return indices;
};
